import { CategoryTypeEnum } from 'entities/Files/types';

export const ReadableCategories: Record<string, string> = {
	all: 'sidebar.menu./files/all',
	[CategoryTypeEnum.custom]: `sidebar.menu./files/${CategoryTypeEnum.custom}`,
	[CategoryTypeEnum.generative_model]: `sidebar.menu./files/${CategoryTypeEnum.generative_model}`,
};
